"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Icon_1 = __importDefault(require("../Icon"));
var styles_1 = __importDefault(require("./styles"));
var FileInput = function (_a) {
    var onChange = _a.onChange, isDisabled = _a.isDisabled, className = _a.className, form = _a.form, isInvalid = _a.isInvalid;
    var _b = react_1.useState(), file = _b[0], setFile = _b[1];
    var fileInputRef = react_1.useRef(null);
    var classNames = (className || '') + " " + (isDisabled ? 'disabled' : '') + " " + (isInvalid ? 'invalid' : '');
    var handleChange = function (event) {
        var _a;
        var nextFile = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a.item(0);
        setFile(nextFile);
        if (onChange)
            onChange(nextFile);
    };
    var handleSelectClick = function () {
        var _a;
        (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    react_1.useEffect(function () {
        if (form)
            form.addEventListener('reset', setFile.bind(undefined, null));
    }, [form]);
    return (react_1.default.createElement(styles_1.default, { className: classNames },
        react_1.default.createElement("input", { className: "name", type: "text", value: (file === null || file === void 0 ? void 0 : file.name) || '', disabled: true }),
        react_1.default.createElement("button", { onClick: handleSelectClick, disabled: isDisabled },
            react_1.default.createElement(Icon_1.default, { icon: "documents" })),
        react_1.default.createElement("input", { ref: fileInputRef, type: "file", name: "file", onChange: handleChange, hidden: true })));
};
exports.default = FileInput;
//# sourceMappingURL=index.js.map